import React from 'react';
import glamorous from 'glamorous';

export const VXBadge = ({ children }) => (
  <glamorous.Span
    minWidth={10}
    marginLeft={5}
    padding=".3em .5em .2em"
    fontSize=".6em"
    fontWeight={700}
    lineHeight={1}
    color="#fff"
    textAlign="center"
    background="#8CC841"
    borderRadius={4}
  >
    {children}
  </glamorous.Span>
);


// WEBPACK FOOTER //
// ./src/views/visions/vx-badge.js